import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function JiraIntegrationSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.JiraIntegration}/>;
}
